import myRticLogo from '#base/resources/images/myRTIC-Logo.png';
import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { useMediaQuery } from 'react-responsive';

interface TitleProps {
  view: string;
  toolView: string;
  item: any;
  title: string;
}

const DefaultTitle: FunctionComponent<TitleProps> = ({ view, toolView, title = 'MyRTIC' }) =>
  view === 'design' && !toolView ? (
    <>
      <b className='t-inline-flex t-items-center t-gap-2 t-font-bold'>
        <span>Personalize with</span>
        <img src={myRticLogo} alt='MyRTIC Logo' className='t-h-full t-max-h-[20px] t-w-auto t-max-w-full' />
      </b>
    </>
  ) : (
    <>
      <b className='t-font-bold'>{title}</b>
    </>
  );

interface IProps {
  TitleComponent: FunctionComponent<TitleProps>;
  onClick?: (e?) => void;
  view: string;
  toolView: string;
  item: any;
  title: string;
}

const Header = ({ TitleComponent = DefaultTitle, onClick = () => {}, ...props }: IProps) => {
  const isTablet = useMediaQuery({ maxWidth: 1023 });

  return (
    <div className='t-fixed t-left-0 t-right-0 t-top-0 t-z-10 lg:t-static'>
      <p
        className={classNames('t-mb-0 t-flex t-cursor-pointer t-items-center', {
          't-gap-4 t-px-4 t-pb-4 t-text-lg lg:t-text-2xl': !isTablet,
          't-relative t-z-10 t-gap-3 t-border-b t-border-b-gray-300 t-bg-white t-px-[10px] t-py-3 t-text-xs':
            isTablet,
        })}
        onClick={onClick}>
        <FaChevronLeft className='t-text-sm lg:t-text-2xl' color='var(--plum-brand-black)' />
        <span className='t-text-brand-black'>
          <TitleComponent {...props} />
        </span>
      </p>
    </div>
  );
};

export default Header;
